class r extends Error{constructor(r){super(r),this.name="TimeoutError"}toString(){return`Message: ${this.message}`}}export{r as default};
//# sourceMappingURL=TimeoutError.js.map
